import { CronJobDataInputDto } from "../../dtos/cronJob/CronJobDataInputDto";
import { get } from "../../utills/BaseService";

export async function getAllCronJobData(dispatch: any, input: CronJobDataInputDto): Promise<any> {
    return await get(dispatch, '/cronJobData/getAllCronJobData', input);
 };
export async function getAllCronJobStatus(dispatch: any, input: CronJobDataInputDto): Promise<any> {
    return await get(dispatch, '/cronJobStatus/getAllCronJobStatus', input);
 };